var locale = {
  locale: 'us',
  today: 'Today',
  yesterday: 'Yesterday',
  lastThreeDay: ' Last 3 days',
  lastWeek: 'Last week',
  lastMonth: 'Last month',
  lastHalfYear: 'Last 6 months',
  all: 'All'
};
export default locale;